/* eslint-disable react/prop-types */
import * as React from 'react';

export const AddUser = ({ color = '#64748B', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.033 14.0308C5.92894 14.0308 2.46094 16.2798 2.46094 18.9418C2.46094 21.9778 6.78194 22.3288 10.033 22.3288C11.906 22.3288 17.605 22.3288 17.605 18.9218C17.605 16.2698 14.137 14.0308 10.033 14.0308Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0004 11.7369H10.0324C12.8084 11.7369 15.0654 9.47887 15.0654 6.70387C15.0654 3.92887 12.8084 1.67188 10.0324 1.67188C7.2573 1.67188 4.9993 3.92887 4.9993 6.70187C4.9893 9.46787 7.2313 11.7269 10.0004 11.7369Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.2885 9.40441H19.9915V8.14941C19.9915 7.73541 19.6555 7.39941 19.2415 7.39941C18.8275 7.39941 18.4915 7.73541 18.4915 8.14941V9.40441H17.1985C16.7845 9.40441 16.4485 9.74041 16.4485 10.1544C16.4485 10.5684 16.7845 10.9044 17.1985 10.9044H18.4915V12.1594C18.4915 12.5734 18.8275 12.9094 19.2415 12.9094C19.6555 12.9094 19.9915 12.5734 19.9915 12.1594V10.9044H21.2885C21.7025 10.9044 22.0385 10.5684 22.0385 10.1544C22.0385 9.74041 21.7025 9.40441 21.2885 9.40441Z"
      fill={color}
    />
  </svg>
);
